<template>
  <div class="news-detail-wrap">
    <div class="news-breadcrumb">
      当前位置：<span @click="goHome">首页</span><span class="category" @click="goCategory()">> 体育资讯</span><span v-if="detail.title">> {{detail.title}}</span>
    </div>
    <div class="detail-wrap">
      <div class="detail">
        <template v-if="detail && detail.title">
          <h2>{{detail.title}}</h2>
          <div class="info">
            <span>发布时间： {{detail.created_at | formateTime}}</span>
            <span>{{(detail.memberid && detail.memberid.username) ? detail.memberid.username : `用户${detail.member_id}`}}</span>
          </div>
          <template v-if="!isVideo">
            <div class="content" v-html="detail.content"></div>
          </template>
          <template v-else>
            <div class="video-wrap">
              <!-- <div v-if="videoError" class="video-error">
                <img src="@/assets/images/new/nosignal.png" alt="" />
              </div> -->
              <div>
                <video ref="videoPlayer" webkit-playsinline="true" playsinline="true" class="video-js"></video>
              </div>
            </div>
          </template>
          <div class="plays">
            <div @click="consultLike">
              <img v-if="detail.likes && detail.likes.likes" src="@/assets/images/new/zan-red.png"  alt="" />
              <img v-else src="@/assets/images/new/zan.png" alt="" />
              <span>{{detail.is_like}}</span>
            </div>
            <div>
              <img src="@/assets/images/new/comment.png" alt="">
              <span>{{detail.comments}}</span>
            </div>
          </div>
        </template>
        <div class="about">
          <div class="prev" v-if="detail.previous && detail.previous.title" @click="goDetail(detail.previous.id)">
            上一篇：{{detail.previous.title}}
          </div>
          <div class="next" v-if="detail.next && detail.next.title" @click="goDetail(detail.next.id)">
            下一篇：{{detail.next.title}}
          </div>
        </div>
        <div class="comments" v-if="detail && detail.title">
          <div class="reply-wrap">
            <div class="title">发表评论</div>
            <div class="reply-input">
              <el-input
                type="textarea"
                :rows="6"
                resize="none"
                placeholder="我有话说~~~"
                v-model="textarea" />
              <button @click="sendMsg">发表</button>
            </div>
          </div>
          <div class="relies">
            <div class="title">最新评论</div>
            <template v-if="comments.length > 0">
              <div class="comment-details" v-for="(item, idx) in comments" :key="idx">
                <div class="comment-part">
                  <img v-if="item.memberid && item.memberid.face" class="avatar" :src="item.memberid.face" @error="onAvatarError" alt="" />
                  <img v-else class="avatar" src="@/assets/images/default_avatar.png" @error="onAvatarError" alt="" />
                  <div class="comment-right">
                    <div class="comment-info" :data-info="JSON.stringify(item.memberid)">
                      <span v-if="item.memberid && item.memberid.username">{{ item.memberid.username }}</span>
                      <span v-else>用户{{item.member_id}}</span>
                      <img
                        src="@/assets/images/new/writer.png"
                        alt=""
                        class="writer"
                        v-if="Number(detail.member_id) === Number(item.member_id)"
                      />
                    </div>
                    <div class="comment-content">
                      <p>{{ item.content }}</p>
                      <div class="plays">
                        <div :class="{ 'red': item.likes && item.likes.likes }" @click="useConsultLike(item.id)">
                          <img v-if="item.likes && item.likes.likes" src="@/assets/images/new/zan-red.png"  alt="" />
                          <img v-else src="@/assets/images/new/zan.png" alt="" />
                          {{ item.is_like > 99 ? '99+' : item.is_like }}
                        </div>
                        <div @click="showDetails(item)">
                          <img src="@/assets/images/new/comment.png" alt="">
                          <span>{{item.comments}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="comment-bottom">
                      <span>{{ item.created_at | formateReplyTime }}</span>
                      <span class="reply" @click="reply(item.id)">回复</span>
                    </div>
                  </div>
                </div>
                <div class="reply-comment-wrap" v-if="item.id === replyId">
                  <div class="reply-input">
                    <el-input
                      type="textarea"
                      :rows="4"
                      resize="none"
                      placeholder="我有话说~~~"
                      v-model="replyTextarea" />
                    <button class="cancel" @click="cancelReply">取消</button>
                    <button @click="replyMsg">发表</button>
                  </div>
                </div>
                <!-- 如果有更多回复，点击后应该小图显示 -->
                <template v-if="moreReplies[item.id] && showReplies[item.id]">
                  <div class="part-replies" v-for="(comment, idx) in moreReplies[item.id]" :key="idx">
                    <div class="comment-part">
                      <img
                        class="avatar"
                        :src="comment.memberid.face"
                        alt=""
                        @error="onAvatarError"
                      />
                      <div class="comment-right">
                        <div class="comment-info">
                          <span>{{ comment.memberid.username }}</span>
                          <img
                          src="@/assets/images/new/writer.png"
                          alt=""
                          class="writer"
                          v-if="Number(detail.member_id) === Number(comment.member_id)"
                        />
                        </div>
                        <div class="comment-content">
                          <p>{{ comment.content }}</p>
                          <div class="plays">
                            <div :class="{ 'red': comment.likes && comment.likes.likes }" @click="useConsultLike(comment.id, item.id)">
                              <img v-if="comment.likes && comment.likes.likes" src="@/assets/images/new/zan-red.png"  alt="" />
                              <img v-else src="@/assets/images/new/zan.png" alt="" />
                              {{ comment.is_like > 99 ? '99+' : comment.is_like }}
                            </div>
                          </div>
                        </div>
                        <div class="comment-bottom">
                          <span>{{ comment.created_at | formateReplyTime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <div v-if="Number(detail.comments) === 0" class="comments-empty">
              <img src="@/assets/images/new/comments-empty.png" alt="">
              <p>暂无回复，说说我的观点</p>
            </div>
          </div>
        </div>
      </div>
      <div class="more" v-if="aboutList.list && aboutList.list.length > 0">
        <div class="title">
          <p>相关资讯</p>
          <span @click="goCategory(aboutList.consultancyid)">查看更多<img src="@/assets/images/new/more@2x.png" alt=""></span>
        </div>
        <ul>
          <li v-for="(news, idx) in aboutList.list" :key="idx" @click="goDetail(news.id, true)">
            <img :src="news.img" @error="onNewsCoverError" alt="">
            <p class="new-title">{{news.title}}</p>
            <p>
              <span>{{news.created_at | formateTime}}</span>
              <span>{{(news.memberid && news.memberid.username) ? news.memberid.username : `用户${news.member_id}`}}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import "dayjs/locale/zh-cn";
import relativeTime from "dayjs/plugin/relativeTime";
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
dayjs.extend(relativeTime);
dayjs.locale("zh-cn");

export default {
  name: "DetailPage",
  data () {
    return {
      isVideo: false,
      isPlaying: false,
      showPlay: false,
      videoError: false,
      textarea: '',
      replyTextarea: '',
      replyId: null,
      isSending: false,
      isReplying: false,
      detail: {},
      aboutList: {},
      comments: [],
      moreReplies: {},
      showReplies: {},
      videoOptions: {
        autoplay: true,
        controls: true,
        width: "780px",
        height: "400px",
        preload: "auto",
        errorDisplay: false,
        logo: {
          enabled: false
        },
        fullscreenToggle: false
      }
    }
  },
  filters: {
    formateTime: function (val) {
      let time = dayjs(val * 1000).format("YYYY-MM-DD HH:MM:ss");
      return time
    },
    formateHtml: function (html) {
      const re1 = new RegExp("<.+?>","g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const msg = html.replace(re1,'');//执行替换成空字符
      return msg;
    },
    formateReplyTime: function (val) {
      let time = ''
      if (new Date().getTime() - val * 1000 < 60000) {
        time = '1分钟前'
      } else if (new Date().getTime() - val * 1000 < 86400000) {
        time = dayjs().to(val * 1000);
      } else {
        time = dayjs(val * 1000).format("YYYY-MM-DD HH:MM:ss");
      }
      return time
    }
  },
  watch: {
    $route: function (to, from) {
      this.getDetailReq()
    }
  },
  methods: {
    showDetails(item) {
      const id = item.id
      if (item.comments < 1) return
      if (this.showReplies[id]) {
        this.showReplies[`${id}`] = false
      } else {
        if (this.moreReplies[id]) {
          this.showReplies[id] = true
        } else {
          this.getMoreReplies({
            id: id
          })
        }
      }
    },
    getDetail (params) {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      const member_id = this.getCookie('member_id')
      if (member_id) {
        params.member_id = member_id
      }
      axios.get(COMMOND.NEW_BASE_URL + "consult_detail_web", {
        headers: headers,
        params
      }).then((res) => {
        if (!res) this.$router.replace('/news')
        this.detail = res.data.data
        if (this.detail.video_url && this.detail.video_url !== '0') {
          this.isVideo = true
          this.videoOptions.sources = [
            {
              src: this.detail.video_url,
              type: 'video/mp4'
            }
          ]
          this.videoOptions.poster = this.detail.img
          const _this = this
          this.$nextTick(() => {
            this.postPlayVideo({
              list_id: this.detail.id
            })
            if (this.player) {
              this.player.src({ type: 'video/mp4', src: this.detail.video_url });
              this.player.poster(this.detail.img)
              this.videoError = false
            } else {
              this.player = videojs(this.$refs.videoPlayer, this.videoOptions, function ready () {
                _this.player.log('onPlayerReady', _this);
                this.on('playing', () => {
                  _this.showPlay = false
                  _this.isPlaying = true
                })
                this.on('pause', () => {
                  _this.showPlay = true
                  _this.isPlaying = false
                })
                this.on('ended', () => {
                  _this.showPlay = true
                  _this.isPlaying = false
                })
                this.on('click', () => {
                  if (_this.isPlaying) {
                    console.log('暂停了')
                    _this.player.pause()
                    _this.showPlay = true
                  } else{
                    console.log('播放')
                    _this.player.play()
                    _this.showPlay = false
                  }
                })
                this.on('error', (e) => {
                  console.log(e)
                  _this.videoError = true
                  _this.player.poster(require('../assets/images/new/nosignal.png'))
                })
              });
            }
          })
        } else {
          this.isVideo = false
          if (this.player) {
            this.player.dispose()
            this.player = null
          }
        }
      });
    },
    postPlayVideo(query){
      const member_id = this.getCookie('member_id')
      if (member_id) query.member_id = member_id
      axios.post(COMMOND.NEW_BASE_URL + 'consult_paly_web', {
        ...query
      })
    },
    getAboutList (params) {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      const member_id = this.getCookie('member_id')
      if (member_id) {
        params.member_id = member_id
      }
      axios.get(COMMOND.NEW_BASE_URL + "consult_correlation_web", {
        headers: headers,
        params
      }).then((res) => {
        this.aboutList = res.data.data
      });
    },
    goHome () {
      window.open(`/`)
      // this.$router.push({
      //   path: '/'
      // })
    },
    goDetail (id, open = false) {
      if (open) {
        window.open(`/news/detail/${id}`)
      } else {
        this.$router.push({
          name: 'detail',
          params: {
            id: id
          }
        })
      }
    },
    goCategory (id) {
      let navId = this.detail.consultancy_id
      if (typeof id === 'number' || typeof id === 'string') {
        navId = id
      }
      if (navId) {
        window.open(`/news/${navId}`)
        // this.$router.push({
        //   name: 'sub_news',
        //   params: {
        //     navid: navId
        //   }
        // })
      } else {
        window.open(`/news`)
        // this.$router.push({
        //   name: 'news'
        // })
      }
    },
    getAllComments (query) {
      const member_id = this.getCookie('member_id')
      if (member_id) {
        query.member_id = member_id
      }
      axios.get(COMMOND.NEW_BASE_URL + 'consult_pachiraall_web', {
        params: query
      }).then(res => {
        this.comments = res.data.data
      })
    },
    getMoreReplies(query) {
      const member_id = this.getCookie('member_id')
      if (member_id) {
        query.member_id = member_id
      }
      axios.get(COMMOND.NEW_BASE_URL + 'consult_pachiraalls_web', {
        params: query
      }).then(res => {
        const moreReplies = JSON.parse(JSON.stringify(this.moreReplies))
        const showReplies = JSON.parse(JSON.stringify(this.showReplies))
        moreReplies[`${query.id}`] = res.data.data
        showReplies[`${query.id}`] = true
        this.moreReplies = moreReplies
        this.showReplies = showReplies
      })
    },
    appendComments (item, pid) {
      if (pid) {
        const moreReplies = JSON.parse(JSON.stringify(this.moreReplies))
        const showReplies = JSON.parse(JSON.stringify(this.showReplies))
        if (moreReplies[`${pid}`]) {
          moreReplies[`${pid}`] = [item, ...moreReplies[`${pid}`]]
        } else {
          moreReplies[`${pid}`] = [item]
        }
        showReplies[`${pid}`] = true
        this.moreReplies = moreReplies
        this.showReplies = showReplies
        const comments = JSON.parse(JSON.stringify(this.comments))
        const idx = comments.findIndex(item => item.id === pid)
        if (idx > -1) {
          comments[idx].comments = comments[idx].comments + 1
          this.comments = comments
        }
      } else{
        item.comments = 0
        this.comments = [item, ...this.comments]
      }
    },
    // 文章点赞
    consultLike () {
      const cookie = this.getCookie('token')
      const member_id = this.getCookie('member_id')
      const isLogin = cookie ? true : false
      if (isLogin) {
        axios.post(COMMOND.NEW_BASE_URL + 'consult_likes', {
          list_id: Number(this.detail.id),
          member_id: Number(member_id),
        }).then(res => {
          const detail = this.detail
          detail.likes = res.data.data
          if (res.data.data.likes) {
            detail.is_like = this.detail.is_like + 1
          } else {
            detail.is_like = this.detail.is_like - 1
          }
          this.detail = detail
        })
      } else {
        this.pwloginFn()
      }
    },
    useConsultLike(id, pid){
      const cookie = this.getCookie('token')
      const member_id = this.getCookie('member_id')
      const isLogin = cookie ? true : false
      if (isLogin) {
        axios.post(COMMOND.NEW_BASE_URL + 'consult_pachira_like_web', {
          comment_id: Number(id),
          member_id: Number(member_id),
        }).then(res => {
          const likes = res.data.data
          const replies = pid ? JSON.parse(JSON.stringify(this.moreReplies[`${pid}`])) : JSON.parse(JSON.stringify(this.comments))
          const idx = replies.findIndex(item => item.id === id)
          replies[idx].likes = likes
          if (likes.likes) {
            replies[idx].is_like = replies[idx].is_like + 1
          } else {
            replies[idx].is_like = replies[idx].is_like - 1
          }
          if (pid) {
            const moreReplies = JSON.parse(JSON.stringify(this.moreReplies))
            moreReplies[`${pid}`] = replies
            this.moreReplies = moreReplies
          } else {
            this.comments = replies
          }
        })
      } else {
        // this.$router.push({
        //   path: `/msgLogin?url=${this.$route.fullPath}`,
        // })
        this.pwloginFn()
      }
    },
    sendMsg () {
      const cookie = this.getCookie('token')
      const member_id = this.getCookie('member_id')
      const isLogin = cookie ? true : false
      if (isLogin) {
        if (!this.textarea || this.isSending) return
        this.isSending = true
        axios.post(COMMOND.NEW_BASE_URL + 'consult_pachira_web', {
          list_id: Number(this.detail.id),
          member_id: Number(member_id),
          content: this.textarea
        }).then(res => {
          this.textarea = ''
          this.isSending = false
          if ([2001, 2002, 2003].includes(res.data.code)) {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          } else if (res.data.code === 200) {
            this.detail.comments = this.detail.comments + 1
            const reply = res.data.data
            if (typeof reply.created_at !== 'number') {
              reply.created_at = (new Date(reply.created_at).getTime()) / 1000
            }
            this.appendComments(reply)
          }
        }).catch(e => {
          this.isSending = false
        })
      } else {
        // this.$router.push({
        //   path: `/msgLogin?url=${this.$route.fullPath}`,
        // })
        this.pwloginFn()
      }
    },
    reply (id) {
      this.replyId = id
    },
    cancelReply () {
      this.replyId = null
    },
    replyMsg () {
      const cookie = this.getCookie('token')
      const member_id = this.getCookie('member_id')
      const isLogin = cookie ? true : false
      if (isLogin) {
        if (!this.replyTextarea || this.isReplying) return
        this.isReplying = true
        const query = JSON.parse(JSON.stringify({
          list_id: Number(this.detail.id),
          member_id: Number(member_id),
          content: this.replyTextarea,
          id: this.replyId
        }))
        axios.post(COMMOND.NEW_BASE_URL + 'consult_pachiras_web', {
          ...query
        }).then(res => {
          this.replyId = null
          this.replyTextarea = ''
          this.isReplying = false
          if ([2001, 2002, 2003].includes(res.data.code)) {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          } else if (res.data.code === 200) {
            const replies = this.moreReplies[query.id] || []
            if (replies.length < 1) {
              this.getMoreReplies({
                id: query.id
              })
              const showReplies = JSON.parse(JSON.stringify(this.showReplies))
              showReplies[`${query.id}`] = true
              this.showReplies = showReplies
            } else {
              this.detail.comments = this.detail.comments + 1
              const reply = res.data.data
              if (typeof reply.created_at !== 'number') {
                reply.created_at = (new Date(reply.created_at).getTime()) / 1000
              }
              this.appendComments(reply, query.id)
            }
          }
        }).catch(e => {
          this.isReplying = false
        })
      } else {
        // this.$router.push({
        //   path: `/msgLogin?url=${this.$route.fullPath}`,
        // })
        this.pwloginFn()
      }
    },
    pwloginFn() {
      this.initialize();
      $(".layui-layer-tips").remove();
      $(".loading_content1 .dongtai_btn.zhangHao").show();
      $(".loading_content1 .dongtai_btn.dongTai").hide();
      $(".loading").show();
      $(".loading_content1").show();
      $(".loading_content1 .loading_active").removeClass(
          "loading_active"
      );
      $(".loading_content1 .loading_title .zhanghao").addClass(
          "loading_active"
      );
      $(".loading_content1 .zhanghao_content").css("display", "block");
      $(".loading_content1 .forget").css("display", "block");
      $(".loading_content1 .dongtai_content").css("display", "none");
      $(".zhuce").show();
      $(".wx_login").show();
      $(".loading_content2").hide();
      $(".loading_content3").hide();
    },
    initialize() {
      $(".loading input").val("");
      $(
          ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).text("获取验证码");
      $(
          ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).attr("isable", "able");
      $(
          ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).removeClass("noevent");
      $("input[type='button']").val("登录");
    },
    getDetailReq () {
      const id = this.$route.params.id
      if (id) {
        this.getDetail({
          id: id
        })
        this.getAboutList({
          id: id
        })
        this.getAllComments({
          id: id
        })
        // if (this.player) {
        //   this.player.dispose();
        // }
      } else {
        this.$router.go(-1)
      }
    },
    //获取cookie值
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    }
  },
  mounted () {
    this.getDetailReq()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped lang="less">
.news-detail-wrap {
  width: 1200px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 50px;
  .news-breadcrumb {
    padding: 16px;
    font-size: 14px;
    color: #777;
    line-height: 18px;
    cursor: pointer;
    .category {
      color: #2c2c2c;
    }
  }
  .detail-wrap {
    display: flex;
    gap: 20px;
    .detail {
      width: 822px;
      padding: 0 0 0 40px;
      h2 {
        font-size: 28px;
        line-height: 32px;
        color: #232a35;
        font-weight: 500;
        text-align: center;
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        margin-bottom: 16px;
      }
      .info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        line-height: 20px;
        span {
          font-size: 16px;
          color: #777;
        }
      }
      .content {
        font-size: 16px;
        line-height: initial;
        line-height: 2;
        color: #4b4b4b;
        /deep/ p {
          word-break: break-all;
          width: 100% !important;
        }
        /deep/ img {
          display: block;
          margin: 0 auto;
          max-width: 100%;
        }
      }
      .video-wrap {
        width: 780px;
        height: 400px;
      }
      .plays {
        display: flex;
        gap: 20px;
        margin-top: 20px;
        font-size: 16px;
        div {
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 5px;
        }
      }
      .about {
        font-size: 16px;
        color: #777;
        margin-top: 24px;
        padding-bottom: 40px;
        div {
          margin-bottom: 8px;
          line-height: 20px;
          cursor: pointer;
          &:hover {
            color: #C9353F;
          }
        }
      }
      .comments {
        .reply-wrap {
          .reply-input {
            position: relative;
            button {
              border: none;
              position: absolute;
              bottom: 10px;
              right: 10px;
              width: 64px;
              height: 25px;
              background: #C9353F;
              border-radius: 4px;
              color: #fff;
            }
            /deep/ textarea {
              border: none;
              background: #F6F6F6;
              font-size: 18px;
            }
          }
        }
        .title {
          padding-left: 18px;
          position: relative;
          font-size: 24px;
          line-height: 34px;
          color: #232A35;
          font-weight: 500;
          margin: 16px 0;
          &::before {
            content: ' ';
            position: absolute;
            left: 0px;
            height: 20px;
            width: 5px;
            border-radius: 4px;
            top: 8px;
            background: #C9353F;
          }
        }
        .comment-details {
          .comment-part {
            display: flex;
            margin: 15px 0 10px 0;
            .avatar {
              height: 48px;
              width: 48px;
              border-radius: 50%;
              overflow: hidden;
            }
            .comment-right {
              display: flex;
              flex-direction: column;
              padding-left: 10px;
              flex: 1;
              .comment-info {
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                margin-bottom: 5px;
                color: #777;
              }
              .comment-content {
                text-align: left;
                font-size: 16px;
                font-family: PingFangSC-Regular;
                line-height: 24px;
                display: flex;
                align-items: flex-start;
                margin-bottom: 6px;
                gap: 20px;
                p {
                  flex: 1;
                  max-width: 600px;
                  word-break: break-word;
                  line-break: anywhere;
                }
                .plays {
                  display: flex;
                  margin: 0;
                  div {
                    display: flex;
                    img {
                      width: 24px;
                      height: 24px;
                    }
                  }
                }
              }
              .comment-bottom {
                width: 100%;
                display: flex;
                font-size: 12px;
                font-family: PingFangSC-Regular;
                line-height: 17px;
                margin-top: 1px;
                color: #A6A6A6;
                gap: 20px;
                .reply {
                  cursor: pointer;
                }
              }
            }
          }

          .part-replies {
            padding-left: 50px;
            .avatar {
              width: 40px;
              height: 40px;
            }
          }

          .reply-comment-wrap {
            padding-left: 50px;
            .reply-input {
              position: relative;
              button {
                border: none;
                position: absolute;
                bottom: 10px;
                right: 10px;
                width: 64px;
                height: 25px;
                background: #C9353F;
                border-radius: 4px;
                color: #fff;
              }
              .cancel {
                border: none;
                position: absolute;
                bottom: 10px;
                right: 84px;
                width: 64px;
                height: 25px;
                background: #8b8b8b;
                border-radius: 4px;
                color: #fff;
              }
              /deep/ textarea {
                border: none;
                background: #F6F6F6;
                font-size: 18px;
              }
            }
          }

          .more-replies {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #8B8B8B;
            line-height: 18px;
            display: flex;
            justify-content: space-evenly;
          }

          .no-comment {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
              width: 158px;
              height: 126px;
            }

            span {
              color: #808080;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 18px;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .more {
      width: 358px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 0;
        border-bottom: 1px solid #EEEEEE;
        p {
          padding-left: 18px;
          position: relative;
          font-size: 24px;
          line-height: 34px;
          &::before {
            content: ' ';
            position: absolute;
            left: 0px;
            height: 20px;
            width: 5px;
            border-radius: 4px;
            top: 8px;
            background: #C9353F;
          }
        }
        span {
          color: #4B5B76;
          font-size: 14px;
          cursor: pointer;
          line-height: 34px;
          img {
            height: 20px;
            width: 20px;
            position: relative;
            top: 4px;
          }
        }
      }
      ul {
        li {
          margin-bottom: 20px;
          cursor: pointer;
          img {
            display: block;
            width: 358px;
            height: 200px;
            border-radius: 10px;
          }
          .new-title {
            font-size: 18px;
            color: #3C485C;
            line-height: 20px;
            font-weight: 500;
            margin: 20px 4px;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            &:hover {
              color: #C9353F;
            }
          }
          p {
            display: flex;
            justify-content: space-between;
            color: #777;
            font-size: 12px;
          }
        }
      }
    }
  }
}
.comments-empty {
  padding: 50px 0;
  img {
    display: block;
    width: 30%;
    margin: 0 auto;
  }
  p {
    text-align: center;
    margin-top: 20px;
    color: #ccc;
    font-size: 18px;
  }
}
</style>